/**
 * 首页推荐图：public/img/new 下按编号分组
 * 同编号为同一人，如 1-1 ~ 1-4；首页封面取每组第一张，详情页展示该组全部图片
 */
const IMG_DIR = '/img/new';

export const HOME_RECOMMEND_GROUPS = [
  ['1-1.jpg', '1-2.jpg', '1-3.jpg', '1-4.jpg'],
  ['2-1.jpg', '2-2.jpg', '2-3.jpg', '2-4.jpg'],
  ['3-1.jpg', '3-2.jpg', '3-3.jpg', '3-4.jpg'],
  ['4-1.jpg', '4-2.jpg', '4-3.jpg'],
  ['5-1.jpg', '5-2.jpg', '5-3.jpg', '5-4.jpg'],
  ['6-1.jpg', '6-2.jpg', '6-3.jpg', '6-4.jpg'],
  ['7-1.jpg', '7-2.jpg', '7-3.jpg', '7-4.jpg'],
  ['8-1.jpg', '8-2.jpg', '8-3.jpg', '8-4.jpg'],
  ['9-1.jpg', '9-2.jpg', '9-3.jpg', '9-4.jpg'],
  ['10-1.jpg', '10-2.jpg', '10-3.jpg', '10-4.jpg'],
  ['11-1.jpg', '11-2.jpg', '11-3.jpg', '11-4.jpg'],
  ['12-1.jpg', '12-2.jpg', '12-3.jpg', '12-4.jpg'],
  ['13-1.jpg', '13-2.jpg', '13-3.jpg', '13-4.jpg'],
  ['14-1.jpg', '14-2.jpg', '14-3.jpg', '14-4.jpg'],
  ['15-1.jpg', '15-2.jpg', '15-3.jpg', '15-4.jpg'],
].map((files) => files.map((name) => `${IMG_DIR}/${name}`));

/** @deprecated 兼容旧引用：每组封面路径 */
export const HOME_RECOMMEND_IMAGES = HOME_RECOMMEND_GROUPS.map(
  (group) => group[0] || '/img/error.png'
);

/** Encode filename for URL (spaces, parentheses). */
export function encodePublicPath(path) {
  if (!path || typeof path !== 'string') {
    return '';
  }
  if (!path.startsWith('/')) {
    return path;
  }
  const lastSlash = path.lastIndexOf('/');
  const dir = path.slice(0, lastSlash + 1);
  const file = path.slice(lastSlash + 1);
  return dir + encodeURIComponent(file);
}

function getGroupByIndex(index) {
  if (!HOME_RECOMMEND_GROUPS.length) {
    return [];
  }
  const i = Math.abs(Number(index) || 0) % HOME_RECOMMEND_GROUPS.length;
  return HOME_RECOMMEND_GROUPS[i];
}

/** 首页列表封面：每组取第一张（如 1-1.jpg） */
export function getHomeRecommendImage(index) {
  const group = getGroupByIndex(index);
  if (!group.length) {
    return '/img/error.png';
  }
  return encodePublicPath(group[0]);
}

/** 详情页轮播：该人物编号下的全部图片（如 1-1 ~ 1-4） */
export function getHomeRecommendDetailImages(index) {
  const group = getGroupByIndex(index);
  if (!group.length) {
    return ['/img/error.png'];
  }
  return group.map(encodePublicPath);
}

export default HOME_RECOMMEND_GROUPS;
